module.exports = paginationCard = {

  getDivisionLatLng: (pageConfig) ->
    return pageConfig.ell if pageConfig.ell
    return "#{pageConfig.currentDivision.lat},#{pageConfig.currentDivision.lng}" if pageConfig.currentDivision.lat
    return null

  getDivisionLocale: (pageConfig) ->
    return pageConfig.currentDivision.defaultLocale if pageConfig.currentDivision.defaultLocale
    return I18n.locale

  clonableAttributes: [
    'data-limit'
    'data-deal-type'
    'data-is-category-fallback'
    'data-category-fallback'
    'data-filter-query'
    'data-context'
    'data-division'
    'data-division-loc'
    'data-page-type'
    'data-show-options'
    'data-set-label'
    'data-set-id'
    'data-nohero'
    'data-unsafe-deals'
    'data-href-template'
    'data-inclue-query'
  ]

  cloneAttributes: ($node, attrList)->
    newMap = {}
    attrList = attrList || this.clonableAttributes
    _.each attrList, (attr)->
        value = $node.attr(attr)
        newMap[attr] = value if value
    return newMap

  loadButtonAttributes: (loadMoreBtn, pageConfig) ->
    # PLEASE NOTE: this is only for pagination cards, apiQueryBuilder is also called from facetSelectionChanged
    # the easy way to get properties for free there is to define them on pageConfig.occasion instead of pageConfig
    # it is arguable we will simply default the object we return here with pageConfig.occasion to simplify this code
    dealType: loadMoreBtn.attr("data-deal-type")
    isCategoryFallback: loadMoreBtn.attr("data-is-category-fallback")
    categoryFallback: loadMoreBtn.attr("data-category-fallback")
    context: loadMoreBtn.attr("data-context")
    division: loadMoreBtn.attr("data-division") or pageConfig.occasion.division
    sort: pageConfig.sort or false
    noHero: loadMoreBtn.attr("data-nohero") or pageConfig.isTouch or false
    filterQuery: loadMoreBtn.attr("data-filter-query") unless loadMoreBtn.attr("data-inclue-query")
    pageType: loadMoreBtn.attr("data-page-type")
    latLng: loadMoreBtn.attr("data-division-loc") or @getDivisionLatLng(pageConfig)
    divisionLocale: @getDivisionLocale(pageConfig)
    includeHtml: pageConfig.newRender or false
    renderOptions: pageConfig.occasion.renderOptions or false
    unsafe: loadMoreBtn.attr("data-unsafe-deals")
    showOptions: loadMoreBtn.attr("data-show-options") or "false"
    showBestOption: pageConfig.occasion.showBestOption
    showUrgentPerc: pageConfig.occasion.showUrgentPerc
    extraShow: pageConfig.occasion.extraShow
    extraRapiShow: pageConfig.occasion.extraRapiShow
    includeQuery: loadMoreBtn.attr("data-inclue-query") or false

  copyDataAttributes: ($source, $destination) ->
    for i in $source[0].attributes
      if i.nodeName.indexOf('data-') == 0
        $destination.attr(i.nodeName, $source.attr(i.nodeName))

}
